import { hasPermission } from "../../Config/permissions.js";

const AS_USER_TYPES = new Set(["Admin", "ASD", "Authorizer", "Viewer"]);

export const canAddInvoicePayment = (user) =>
  Boolean(
    user &&
      AS_USER_TYPES.has(user.Type) &&
      hasPermission(user, "payment.add"),
  );
